import { render, staticRenderFns } from "./DocumentUploadListComponent.vue?vue&type=template&id=764a5526&scoped=true&"
import script from "./DocumentUploadListComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentUploadListComponent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUploadListComponent.vue?vue&type=style&index=0&id=764a5526&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764a5526",
  null
  
)

export default component.exports